<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem.displayName }} [{{ currentItem.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="!isFormDisable()"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="!!currentItem?.resourceId && !isFormDisable()"
          (onSave)="clickSave(currentItem)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="onDplicate(currentItem.resourceId!)"
          (onDelete)="onDeleteDialog(currentItem.resourceId!)"></action-bar>
      </div>
    </div>
    <div>
      <div class="identification" [class]="{ 'disabled-form': isFormDisable() }">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="10" required [readonly]="isFormDisable()" />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'ref_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" required [readonly]="isFormDisable()" />
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-3">
              <mat-form-field>
                <mat-label>{{ 'ref_field_family' | translate }}</mat-label>
                <mat-select formControlName="familyId" required>
                  <mat-option *ngFor="let f of families" [value]="f.familyId"> {{ f.familyDisplayName }} [{{ f.familyCode }}] </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.owner.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </div>
            <div class="col-2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.creator.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field>
                <mat-label>{{ 'common_field_description' | translate }}</mat-label>
                <textarea type="text" formControlName="description" rows="3" matInput [readonly]="isFormDisable()"></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="atelier" [class]="{ 'disabled-form': isFormDisable() }">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section_atelier' | translate }}</h3>
          <button mat-mini-fab (click)="addEngin()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <div>
          <mat-accordion hideToggle>
            <mat-expansion-panel expanded>
              <mat-expansion-panel-header #panel (click)="panel._toggle()">
                <mat-panel-title>
                  <div class="row text-bold">
                    <div class="col-1 text-center">
                      <mat-icon (click)="panel._toggle()"> {{ panel._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                    </div>
                    <div class="col-1">{{ 'common_field_code' | translate }}</div>
                    <div class="col-3">{{ 'common_field_label' | translate }}</div>
                    <div class="col-1 text-center">{{ 'common_field_quantity' | translate }}</div>
                    <div class="col-2">{{ 'ref_field_work_unit' | translate }}</div>
                    <div class="col-2">{{ 'project_col_energy' | translate }}</div>
                    <div class="col-1 text-center">{{ 'engin_col_order' | translate }}</div>
                    <div class="col-1 text-center">{{ 'engin_col_actions' | translate }}</div>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" [ngClass]="{ backgroundColor: index % 2 == 0, 'row-error': item.vehicleUnavailable || item.energyUnavailable }" *ngFor="let item of currentItem?.engins; let index = index">
                <div class="col-1 badge-cell">
                  <badge-statut [item]="item"></badge-statut>
                </div>
                <div class="col-1">
                  {{ item.code }}
                </div>
                <div class="col-3 engin-displayname warn-cell">
                  {{ item.displayName }}
                  <mat-icon *ngIf="item.vehicleUnavailable" class="engin-warn" matTooltip="{{ 'atelier_error_vehicle_unavailable' | translate }}">block</mat-icon>
                </div>
                <div class="col-1 text-center">
                  {{ item.quantity }}
                </div>
                <div class="col-2">{{ 'engin_field_nb_engins' | translate }}</div>
                <div class="col-2 warn-cell">
                  <mat-form-field *ngIf="item.ruade; else enginEnergyText">
                    <mat-select [value]="item.energyId" (selectionChange)="onEnginEnergyChange(item, $event.value)" [disabled]="isFormDisable()">
                      <mat-option *ngFor="let p of energies" [value]="p.resourceId">
                        {{ p.displayName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <ng-template #enginEnergyText>
                    <span>{{ getEnginEnergyLabel(item) }}</span>
                  </ng-template>
                  <mat-icon *ngIf="item.energyUnavailable" class="engin-warn" matTooltip="{{ 'atelier_error_energy_unavailable' | translate }}">block</mat-icon>
                </div>
                <div class="col-1 text-center icon-color order-cell">
                  <mat-icon (click)="enginMove(currentItem.engins || [], index, index - 1)" *ngIf="index != 0">arrow_upward</mat-icon>
                  <mat-icon (click)="enginMove(currentItem.engins || [], index, index + 1)" *ngIf="index + 1 != currentItem?.engins?.length">arrow_downward</mat-icon>
                </div>
                <div class="col-1 icon-color text-center actions-cell">
                  <mat-icon (click)="editEngin(item)">edit</mat-icon>
                  <mat-icon (click)="deleteEnginFromList(index, currentItem.engins || [])">delete_outline</mat-icon>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>

      <div class="row">
        <div class="version col-6">
          <h3 class="title-margin-top" style="opacity: 0.8">{{ 'ref_section_db_version' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-12">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_choose_version' | translate }}</mat-label>
                  <mat-select [multiple]="false" formControlName="versionId" (selectionChange)="onVersionChange($event.value)">
                    <mat-option *ngFor="let p of dbVersions" [value]="p.versionId">
                      {{ p.versionName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="cout-journee" [class]="{ 'disabled-form': isFormDisable() }">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section_env_cost_day' | translate }}</h3>
          <mat-card formGroupName="ceu">
            <div class="row" *ngIf="ceuError">
              <div class="col-12 mat-error">
                <mat-icon class="deleted">error</mat-icon>
                {{ 'snackbar_resource_not_available' | translate }}
              </div>
            </div>
            <div class="row" *ngIf="!ceuError">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceu?.get('en')?.value | localizedNumber: '1.0-3'" required [disabled]="true" />
                </mat-form-field>
                <span *ngIf="formCrls.ceu?.get('en')?.invalid && formSubmitted" class="mat-error">{{ 'ref_error_energy_required' | translate }}</span>
              </div>
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceu?.get('co')?.value | localizedNumber: '1.0-3'" required [disabled]="true" />
                </mat-form-field>
                <span *ngIf="formCrls.ceu?.get('co')?.invalid && formSubmitted" class="mat-error">{{ 'ref_error_energy_required' | translate }}</span>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="cout-heure" [class]="{ 'disabled-form': isFormDisable() }" *ngIf="!ceuError">
        <div class="title title-margin-top">
          <h3>{{ 'engin_section_env_cost_hour' | translate }}</h3>
          <mat-card formGroupName="ceuHeure">
            <div class="row">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceuHeure?.get('en')?.value | localizedNumber: '1.0-3'" required [disabled]="true" />
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput type="text" [value]="formCrls.ceuHeure?.get('co')?.value | localizedNumber: '1.0-3'" required [disabled]="true" />
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="ressource" #resourceSection>
        <div class="title title-margin-top">
          <h3>{{ 'ref_section_resource_type' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_project_type' | translate }}</mat-label>
                  <mat-select [multiple]="true" formControlName="projectType" [compareWith]="compareProjectTypes" required>
                    <mat-option *ngFor="let p of projectTypes" [value]="p" [disabled]="isFormDisable()">
                      {{ p.displayName | localizedLabel: 'projectType' : p.code }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.projectType.invalid && (form.controls.projectType.touched || this.formSubmitted)" class="mat-error">{{ form.controls.projectType.errors?.validateProjectType | translate }}</span>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </form>
</div>
